import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getBearerString } from "../utils/Auth";
import { root_url } from "../setting";
import axios from "axios";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import DaumPostcode from "react-daum-postcode";


const AdminApplication = () => {
  const location = useLocation();
  // joinSeq가 있는 경우, 수정
  const queryParams = new URLSearchParams(location.search);
  const joinSeq = queryParams.get("joinSeq");

  const [address, setAddress] = useState({
    zonecode: '',
    roadAddress: '',
    buildingName: '',
  });
  const [joiner, setJoiner] = useState({});
  const [runner, setRunner] = useState({});
  const [ticketInfo, setTicketInfo] = useState([]);
  const [popupShow, setPopupShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [souvenirOptionList, setSouvenirOptionList] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      url: `${root_url}/api/join/ticket-info`,
    })
      .then((res) => {
        if (res.status === 200) {
          let { data } = res;
          console.log(data);
          setTicketInfo(
            data.filter((ticket) => ticket.ticketType === "offline")
          );
          setSouvenirOptionList(
            data[0].choiceOption.split(",").map((option) => {
              return option.trim();
            })
          );
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
      });
  }, []);

  useEffect(() => {
    if (joinSeq) {
      // query parameter로부터 joinSeq 정보 받은 경우, 수정
      let accessToken = getBearerString();
      let headers = {
        Authorization: accessToken,
      };
      axios({
        method: "get",
        url: `${root_url}/api/admin/applicant/findby?joinSeq=${joinSeq}`,
        headers: headers,
      })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res;
            const { applicant, runnersByTicketType } = data;
            // 단체접수인지 확인
            if (applicant.exponent) {
              alert('단체접수는 단체접수 관리에서 수정해주세요.');
              window.location.href = '/admin/reception/application/group?joinSeq=' + joinSeq;
            }
            setIsEditMode(true);
            setJoiner(applicant);
            const roadAddress =
              applicant.zipAddress.indexOf("(") >= 0
                ? applicant.zipAddress.split("(")[0]
                : applicant.zipAddress.split("(")[0];
            const buildingName =
              applicant.zipAddress.indexOf("(") >= 0
                ? applicant.zipAddress.split("(")[1].slice(0, -1)
                : "";
            setAddress({
              zonecode: applicant.zipcode,
              roadAddress: roadAddress,
              buildingName: buildingName,
            });
            //set runner data
            const runner_list = [];
            for (let runners in runnersByTicketType) {
              runner_list.push(...runnersByTicketType[runners]);
            }
            console.log(runner_list);
            setRunner(runner_list[0]);
          }
        })
        .catch((err) => {
          if (err.response.status === 403) {
            alert("권한이 존재하지 않습니다.");
            localStorage.setItem("accessToken", "");
            window.location.href = "/admin/login";
          }
        });
    } else {
      // 신청 페이지의 경우, 초기 정보 설정
      setIsEditMode(false);
      setJoiner({ paymentType: 'BANK', paymentStatus: 'RSVT', amount: ticketInfo[0]?.ticketPrice });
      setRunner({
        gender: "M",
        ticketName: ticketInfo[0]?.ticketName,
        ticketSeq: ticketInfo[0]?.ticketSeq,
        souvenir: "티셔츠",
        choiceOption: souvenirOptionList[0], // 첫번째 사이즈
      });
      console.log(joiner);
      console.log(runner);
    }
  }, [joinSeq, ticketInfo, souvenirOptionList]);

  const onCompletePostCode = ({ zonecode, roadAddress, buildingName }) => {
    setPopupShow(false);
    setAddress({
      zonecode,
      roadAddress,
      buildingName,
    });
  };
  const onAdminApply = () => {
    // 신청 버튼
    // set brief
    joiner.brief = `${joiner.joinerName}${joiner.cellphone.slice(
      joiner.cellphone.length - 4,
      joiner.cellphone.length
    )}`;
    axios({
      method: "post",
      url: `${root_url}/api/applicant/applyFor`,
      data: {
        joiner: {
          ...joiner,
          zipcode: address.zonecode,
          zipAddress: `${address.roadAddress}(${address.buildingName})`,
          address: joiner.address,
        }, runners: [runner]
      },
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.status === 200) {
        alert("접수가 완료되었습니다");
        window.location.href = "/admin/reception/receptionist?pageNo=1&rowCount=10";
      } else {
        alert("신청이 실패하였습니다.");
      }
    });
  }
  const onAdminUpdate = () => {
    // 수정 버튼
    let accessToken = getBearerString();
    let headers = {
      Authorization: accessToken,
    };
    let data = {
      joiner: {
        ...joiner,
        zipcode: address.zonecode,
        zipAddress: `${address.roadAddress}(${address.buildingName})`,
        address: joiner.address,
      },
      runners: [runner]
    };
    console.log(data);
    axios({
      method: "put",
      url: `${root_url}/api/admin/application/update`,
      headers: headers,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          alert("수정이 완료되었습니다. 결제상태도 초기화됩니다.");
          window.location.href = "/admin/reception/receptionist?pageNo=1&rowCount=10";
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
      });
  }

  return (
    <Container>
      <Container className="mb-5">
        <h1> {isEditMode ? "대리 수정(개인)" : "대리 접수(개인)"}</h1>
        <Row className="text-md-center text-start text-custom-color mb-5 mt-5">
          <h3>접수자 정보</h3>
        </Row>
        {
          isEditMode && (
            <>
              <Form.Label className="fw-bold text-secondary">접수번호</Form.Label>
              <input
                type="number"
                className="form-in-class"
                value={joinSeq}
                disabled
              />
              <Form.Label className="fw-bold text-secondary">결제 상태</Form.Label>
              <input
                type="text"
                className="form-in-class"
                value={joiner.paymentStatus === "CMPL" ? "입금완료" : joiner.paymentStatus === 'CNCL' ? "참가취소" : "입금대기"}
                disabled
              />
              <Form.Label className="fw-bold text-secondary">결제 방법</Form.Label>
              <input
                type="text"
                className="form-in-class"
                value={joiner.paymentType === 'BANK' ? '계좌이체' : '카드결제'}
                disabled
              />
            </>
          )
        }
        <Form.Label className="fw-bold">이름</Form.Label>
        <input
          type="text"
          className="form-in-class"
          placeholder="홍길동"
          value={joiner.joinerName}
          onChange={(e) => setJoiner({ ...joiner, joinerName: e.target.value })}
        />
        <Form.Label className="fw-bold">전화번호(-제외 11자 이내)</Form.Label>
        <input
          type="text"
          className="form-in-class"
          placeholder="01012345678"
          value={joiner.cellphone}
          onChange={(e) => setJoiner({ ...joiner, cellphone: e.target.value })}
        />
        <Form.Label className="fw-bold">주소</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="text"
              placeholder="우편번호"
              value={address.zonecode}
              onClick={() => setPopupShow((popupShow) => !popupShow)}
            />
          </Col>
          <Col>
            <Button
              className="border bg-custom-color mb-4"
              onClick={() => setPopupShow((popupShow) => !popupShow)}
            >
              우편번호 찾기
            </Button>
          </Col>
        </Row>

        <Form.Control
          type="text"
          placeholder="주소"
          onClick={() => setPopupShow(!popupShow)}
          value={
            address.roadAddress &&
            `${address.roadAddress}(${address.buildingName})`
          }
          onChange={() => {
            console.log("");
          }}
          className="mb-4"
        />
        <input
          type="text"
          className="form-in-class"
          placeholder="상세주소"
          value={joiner.address}
          onChange={(e) => setJoiner({ ...joiner, address: e.target.value })}
        />
        {/* RunnersParticipantForm을 참고하여 만든 관리자용 참가자 수정 컴포넌트 */}
        <Row className="text-start text-custom-color mb-5 mt-5">
          <h3>참가자 정보</h3>
        </Row>
        <div style={{ overflowX: "scroll", margin: 0 }}>
          <Table style={{ minWidth: "900px" }}>
            <thead>
              <tr>
                <th width={"12%"}>이름</th>
                <th width={"12%"}>생년월일</th>
                <th width={"10%"}>성별</th>
                <th width={"14%"}>전화번호</th>
                <th width={"18%"}>종목</th>
                <th>기념품</th>
                <th>기념품 옵션</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    className="form-in-class"
                    placeholder="홍길동"
                    value={runner.runnerName}
                    onChange={(e) => {
                      setRunner({ ...runner, runnerName: e.target.value });
                    }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-in-class"
                    placeholder="20000101"
                    value={runner.birthday}
                    onChange={(e) => {
                      setRunner({ ...runner, birthday: e.target.value });
                    }}
                  />
                </td>
                <td>
                  <select
                    value={runner.gender}
                    onChange={(e) => {
                      setRunner({ ...runner, gender: e.target.value });
                    }}
                    className="custom-select"
                  >
                    <option value="M">남</option>
                    <option value="F">여</option>
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    className="form-in-class"
                    placeholder="01012345678"
                    value={runner.cellphone}
                    onChange={(e) => {
                      setRunner({ ...runner, cellphone: e.target.value });
                    }}
                  />
                </td>
                <td>
                  <select
                    value={runner.ticketName}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setRunner({
                        ...runner,
                        ticketName: e.target.value,
                        ticketSeq: ticketInfo.find((ticket) => ticket.ticketName === e.target.value).ticketSeq,
                      });
                      setJoiner({
                        ...joiner,
                        amount: ticketInfo.find((ticket) => ticket.ticketName === e.target.value).ticketPrice,
                        deposit: ticketInfo.find((ticket) => ticket.ticketName === e.target.value).ticketPrice,
                      });
                      console.log(runner);
                    }}
                    className="custom-select"
                  >
                    {ticketInfo.map((ticket, index) => {
                      return (
                        <option key={index} value={ticket.ticketName}>
                          {ticket.ticketName}
                        </option>
                      );
                    })}
                  </select>
                </td>
                <td>
                  {runner.souvenir}
                </td>
                <td>
                  <select
                    value={runner.choiceOption}
                    onChange={(e) => {
                      setRunner({ ...runner, choiceOption: e.target.value });
                    }}
                    className="custom-select"
                  >
                    {souvenirOptionList.map((option, index) => {
                      return (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      );
                    }
                    )}
                  </select>
                </td>
              </tr>
            </tbody>
          </Table>
          {isEditMode ? <Button onClick={onAdminUpdate}>수정</Button> : <Button onClick={onAdminApply}>신청</Button>}
        </div>
      </Container>
      {/* kakao map modal */}
      <Modal
        show={popupShow}
        onHide={() => setPopupShow(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <DaumPostcode onComplete={onCompletePostCode} />
        </Modal.Body>
      </Modal>
    </Container >);
}

export default AdminApplication;
